/* adpbtds-bmsm.js — All JS for the BMSM section — v2 */

(function() {
  var sectionEl = document.querySelector('.hdt-buy-more-save-more-section');
  if (!sectionEl) return;

  var sectionId = sectionEl.dataset.sectionId;
  var variantsScript = document.getElementById('bmsm-product-variants-' + sectionId);
  if (!variantsScript) return;
  var variantsData = JSON.parse(variantsScript.textContent);

  /* ── Hardcoded variant IDs (all 360 — bypasses Liquid's 250 cap) ── */
  var variantMap = {
'32A|Beige|1 Pack':52050943901976,'32A|Beige|2 Packs':52050943934744,'32A|Beige|3 Packs':52050943967512,
'32A|Onyx|1 Pack':52050944000280,'32A|Onyx|2 Packs':52050944033048,'32A|Onyx|3 Packs':52050944065816,
'32A|Caramel|1 Pack':52050944098584,'32A|Caramel|2 Packs':52050944131352,'32A|Caramel|3 Packs':52050944164120,
'32A|Ivory|1 Pack':52050944196888,'32A|Ivory|2 Packs':52050944229656,'32A|Ivory|3 Packs':52050944262424,
'32A|Cocoa|1 Pack':52050944295192,'32A|Cocoa|2 Packs':52050944327960,'32A|Cocoa|3 Packs':52050944360728,
'32B|Beige|1 Pack':52050944393496,'32B|Beige|2 Packs':52050944426264,'32B|Beige|3 Packs':52050944459032,
'32B|Onyx|1 Pack':52050944491800,'32B|Onyx|2 Packs':52050944524568,'32B|Onyx|3 Packs':52050944557336,
'32B|Caramel|1 Pack':52050944590104,'32B|Caramel|2 Packs':52050944622872,'32B|Caramel|3 Packs':52050944655640,
'32B|Ivory|1 Pack':52050944688408,'32B|Ivory|2 Packs':52050944721176,'32B|Ivory|3 Packs':52050944753944,
'32B|Cocoa|1 Pack':52050944786712,'32B|Cocoa|2 Packs':52050944819480,'32B|Cocoa|3 Packs':52050944852248,
'32C|Beige|1 Pack':52050944885016,'32C|Beige|2 Packs':52050944917784,'32C|Beige|3 Packs':52050944950552,
'32C|Onyx|1 Pack':52050944983320,'32C|Onyx|2 Packs':52050945016088,'32C|Onyx|3 Packs':52050945048856,
'32C|Caramel|1 Pack':52050945081624,'32C|Caramel|2 Packs':52050945114392,'32C|Caramel|3 Packs':52050945147160,
'32C|Ivory|1 Pack':52050945179928,'32C|Ivory|2 Packs':52050945212696,'32C|Ivory|3 Packs':52050945245464,
'32C|Cocoa|1 Pack':52050945278232,'32C|Cocoa|2 Packs':52050945311000,'32C|Cocoa|3 Packs':52050945343768,
'32D|Beige|1 Pack':52050945376536,'32D|Beige|2 Packs':52050945409304,'32D|Beige|3 Packs':52050945442072,
'32D|Onyx|1 Pack':52050945474840,'32D|Onyx|2 Packs':52050945507608,'32D|Onyx|3 Packs':52050945540376,
'32D|Caramel|1 Pack':52050945573144,'32D|Caramel|2 Packs':52050945605912,'32D|Caramel|3 Packs':52050945638680,
'32D|Ivory|1 Pack':52050945671448,'32D|Ivory|2 Packs':52050945704216,'32D|Ivory|3 Packs':52050945736984,
'32D|Cocoa|1 Pack':52050945769752,'32D|Cocoa|2 Packs':52050945802520,'32D|Cocoa|3 Packs':52050945835288,
'32E|Beige|1 Pack':52050945868056,'32E|Beige|2 Packs':52050945900824,'32E|Beige|3 Packs':52050945933592,
'32E|Onyx|1 Pack':52050945966360,'32E|Onyx|2 Packs':52050945999128,'32E|Onyx|3 Packs':52050946031896,
'32E|Caramel|1 Pack':52050946064664,'32E|Caramel|2 Packs':52050946097432,'32E|Caramel|3 Packs':52050946130200,
'32E|Ivory|1 Pack':52050946162968,'32E|Ivory|2 Packs':52050946195736,'32E|Ivory|3 Packs':52050946228504,
'32E|Cocoa|1 Pack':52050946261272,'32E|Cocoa|2 Packs':52050946294040,'32E|Cocoa|3 Packs':52050946326808,
'32F|Beige|1 Pack':52050946359576,'32F|Beige|2 Packs':52050946392344,'32F|Beige|3 Packs':52050946425112,
'32F|Onyx|1 Pack':52050946457880,'32F|Onyx|2 Packs':52050946490648,'32F|Onyx|3 Packs':52050946523416,
'32F|Caramel|1 Pack':52050946556184,'32F|Caramel|2 Packs':52050946588952,'32F|Caramel|3 Packs':52050946621720,
'32F|Ivory|1 Pack':52050946654488,'32F|Ivory|2 Packs':52050946687256,'32F|Ivory|3 Packs':52050946720024,
'32F|Cocoa|1 Pack':52050946752792,'32F|Cocoa|2 Packs':52050946785560,'32F|Cocoa|3 Packs':52050946818328,
'34A|Beige|1 Pack':52050946851096,'34A|Beige|2 Packs':52050946883864,'34A|Beige|3 Packs':52050946916632,
'34A|Onyx|1 Pack':52050946949400,'34A|Onyx|2 Packs':52050946982168,'34A|Onyx|3 Packs':52050947014936,
'34A|Caramel|1 Pack':52050947047704,'34A|Caramel|2 Packs':52050947080472,'34A|Caramel|3 Packs':52050947113240,
'34A|Ivory|1 Pack':52050947146008,'34A|Ivory|2 Packs':52050947178776,'34A|Ivory|3 Packs':52050947211544,
'34A|Cocoa|1 Pack':52050947244312,'34A|Cocoa|2 Packs':52050947277080,'34A|Cocoa|3 Packs':52050947309848,
'34B|Beige|1 Pack':52050947342616,'34B|Beige|2 Packs':52050947375384,'34B|Beige|3 Packs':52050947408152,
'34B|Onyx|1 Pack':52050947440920,'34B|Onyx|2 Packs':52050947473688,'34B|Onyx|3 Packs':52050947506456,
'34B|Caramel|1 Pack':52050947539224,'34B|Caramel|2 Packs':52050947571992,'34B|Caramel|3 Packs':52050947604760,
'34B|Ivory|1 Pack':52050947637528,'34B|Ivory|2 Packs':52050947670296,'34B|Ivory|3 Packs':52050947703064,
'34B|Cocoa|1 Pack':52050947735832,'34B|Cocoa|2 Packs':52050947768600,'34B|Cocoa|3 Packs':52050947801368,
'34C|Beige|1 Pack':52050947834136,'34C|Beige|2 Packs':52050947866904,'34C|Beige|3 Packs':52050947899672,
'34C|Onyx|1 Pack':52050947932440,'34C|Onyx|2 Packs':52050947965208,'34C|Onyx|3 Packs':52050947997976,
'34C|Caramel|1 Pack':52050948030744,'34C|Caramel|2 Packs':52050948063512,'34C|Caramel|3 Packs':52050948096280,
'34C|Ivory|1 Pack':52050948129048,'34C|Ivory|2 Packs':52050948161816,'34C|Ivory|3 Packs':52050948194584,
'34C|Cocoa|1 Pack':52050948227352,'34C|Cocoa|2 Packs':52050948260120,'34C|Cocoa|3 Packs':52050948292888,
'34D|Beige|1 Pack':52050948325656,'34D|Beige|2 Packs':52050948358424,'34D|Beige|3 Packs':52050948391192,
'34D|Onyx|1 Pack':52050948423960,'34D|Onyx|2 Packs':52050948456728,'34D|Onyx|3 Packs':52050948489496,
'34D|Caramel|1 Pack':52050948522264,'34D|Caramel|2 Packs':52050948555032,'34D|Caramel|3 Packs':52050948587800,
'34D|Ivory|1 Pack':52050948620568,'34D|Ivory|2 Packs':52050948653336,'34D|Ivory|3 Packs':52050948686104,
'34D|Cocoa|1 Pack':52050948718872,'34D|Cocoa|2 Packs':52050948751640,'34D|Cocoa|3 Packs':52050948784408,
'34E|Beige|1 Pack':52050948817176,'34E|Beige|2 Packs':52050948849944,'34E|Beige|3 Packs':52050948882712,
'34E|Onyx|1 Pack':52050948915480,'34E|Onyx|2 Packs':52050948948248,'34E|Onyx|3 Packs':52050948981016,
'34E|Caramel|1 Pack':52050949013784,'34E|Caramel|2 Packs':52050949046552,'34E|Caramel|3 Packs':52050949079320,
'34E|Ivory|1 Pack':52050949112088,'34E|Ivory|2 Packs':52050949144856,'34E|Ivory|3 Packs':52050949177624,
'34E|Cocoa|1 Pack':52050949210392,'34E|Cocoa|2 Packs':52050949243160,'34E|Cocoa|3 Packs':52050949275928,
'34F|Beige|1 Pack':52050949308696,'34F|Beige|2 Packs':52050949341464,'34F|Beige|3 Packs':52050949374232,
'34F|Onyx|1 Pack':52050949407000,'34F|Onyx|2 Packs':52050949439768,'34F|Onyx|3 Packs':52050949472536,
'34F|Caramel|1 Pack':52050949505304,'34F|Caramel|2 Packs':52050949538072,'34F|Caramel|3 Packs':52050949570840,
'34F|Ivory|1 Pack':52050949603608,'34F|Ivory|2 Packs':52050949636376,'34F|Ivory|3 Packs':52050949669144,
'34F|Cocoa|1 Pack':52050949701912,'34F|Cocoa|2 Packs':52050949734680,'34F|Cocoa|3 Packs':52050949767448,
'36A|Beige|1 Pack':52050949800216,'36A|Beige|2 Packs':52050949832984,'36A|Beige|3 Packs':52050949865752,
'36A|Onyx|1 Pack':52050949898520,'36A|Onyx|2 Packs':52050949931288,'36A|Onyx|3 Packs':52050949964056,
'36A|Caramel|1 Pack':52050949996824,'36A|Caramel|2 Packs':52050950029592,'36A|Caramel|3 Packs':52050950062360,
'36A|Ivory|1 Pack':52050950095128,'36A|Ivory|2 Packs':52050950127896,'36A|Ivory|3 Packs':52050950160664,
'36A|Cocoa|1 Pack':52050950193432,'36A|Cocoa|2 Packs':52050950226200,'36A|Cocoa|3 Packs':52050950258968,
'36B|Beige|1 Pack':52050950291736,'36B|Beige|2 Packs':52050950324504,'36B|Beige|3 Packs':52050950357272,
'36B|Onyx|1 Pack':52050950390040,'36B|Onyx|2 Packs':52050950422808,'36B|Onyx|3 Packs':52050950455576,
'36B|Caramel|1 Pack':52050950488344,'36B|Caramel|2 Packs':52050950521112,'36B|Caramel|3 Packs':52050950553880,
'36B|Ivory|1 Pack':52050950586648,'36B|Ivory|2 Packs':52050950619416,'36B|Ivory|3 Packs':52050950652184,
'36B|Cocoa|1 Pack':52050950684952,'36B|Cocoa|2 Packs':52050950717720,'36B|Cocoa|3 Packs':52050950750488,
'36C|Beige|1 Pack':52050950783256,'36C|Beige|2 Packs':52050950816024,'36C|Beige|3 Packs':52050950848792,
'36C|Onyx|1 Pack':52050950881560,'36C|Onyx|2 Packs':52050950914328,'36C|Onyx|3 Packs':52050950947096,
'36C|Caramel|1 Pack':52050950979864,'36C|Caramel|2 Packs':52050951012632,'36C|Caramel|3 Packs':52050951045400,
'36C|Ivory|1 Pack':52050951078168,'36C|Ivory|2 Packs':52050951110936,'36C|Ivory|3 Packs':52050951143704,
'36C|Cocoa|1 Pack':52050951176472,'36C|Cocoa|2 Packs':52050951209240,'36C|Cocoa|3 Packs':52050951242008,
'36D|Beige|1 Pack':52050951274776,'36D|Beige|2 Packs':52050951307544,'36D|Beige|3 Packs':52050951340312,
'36D|Onyx|1 Pack':52050951373080,'36D|Onyx|2 Packs':52050951405848,'36D|Onyx|3 Packs':52050951438616,
'36D|Caramel|1 Pack':52050951471384,'36D|Caramel|2 Packs':52050951504152,'36D|Caramel|3 Packs':52050951536920,
'36D|Ivory|1 Pack':52050951569688,'36D|Ivory|2 Packs':52050951602456,'36D|Ivory|3 Packs':52050951635224,
'36D|Cocoa|1 Pack':52050951667992,'36D|Cocoa|2 Packs':52050951700760,'36D|Cocoa|3 Packs':52050951733528,
'36E|Beige|1 Pack':52050951766296,'36E|Beige|2 Packs':52050951799064,'36E|Beige|3 Packs':52050951831832,
'36E|Onyx|1 Pack':52050951864600,'36E|Onyx|2 Packs':52050951897368,'36E|Onyx|3 Packs':52050951930136,
'36E|Caramel|1 Pack':52050951962904,'36E|Caramel|2 Packs':52050951995672,'36E|Caramel|3 Packs':52050952028440,
'36E|Ivory|1 Pack':52050952061208,'36E|Ivory|2 Packs':52050952093976,'36E|Ivory|3 Packs':52050952126744,
'36E|Cocoa|1 Pack':52050952159512,'36E|Cocoa|2 Packs':52050952192280,'36E|Cocoa|3 Packs':52050952225048,
'38A|Beige|1 Pack':52050952257816,'38A|Beige|2 Packs':52050952290584,'38A|Beige|3 Packs':52050952323352,
'38A|Onyx|1 Pack':52050952356120,'38A|Onyx|2 Packs':52050952388888,'38A|Onyx|3 Packs':52050952421656,
'38A|Caramel|1 Pack':52050952454424,'38A|Caramel|2 Packs':52050952487192,'38A|Caramel|3 Packs':52050952519960,
'38A|Ivory|1 Pack':52050952552728,'38A|Ivory|2 Packs':52050952585496,'38A|Ivory|3 Packs':52050952618264,
'38A|Cocoa|1 Pack':52050952651032,'38A|Cocoa|2 Packs':52050952683800,'38A|Cocoa|3 Packs':52050952716568,
'38B|Beige|1 Pack':52050952749336,'38B|Beige|2 Packs':52050952782104,'38B|Beige|3 Packs':52050952814872,
'38B|Onyx|1 Pack':52050952847640,'38B|Onyx|2 Packs':52050952880408,'38B|Onyx|3 Packs':52050952913176,
'38B|Caramel|1 Pack':52050952945944,'38B|Caramel|2 Packs':52050952978712,'38B|Caramel|3 Packs':52050953011480,
'38B|Ivory|1 Pack':52050953044248,'38B|Ivory|2 Packs':52050953077016,'38B|Ivory|3 Packs':52050953109784,
'38B|Cocoa|1 Pack':52050953142552,'38B|Cocoa|2 Packs':52050953175320,'38B|Cocoa|3 Packs':52050953208088,
'38C|Beige|1 Pack':52050953240856,'38C|Beige|2 Packs':52050953273624,'38C|Beige|3 Packs':52050953306392,
'38C|Onyx|1 Pack':52050953339160,'38C|Onyx|2 Packs':52050953371928,'38C|Onyx|3 Packs':52050953404696,
'38C|Caramel|1 Pack':52050953437464,'38C|Caramel|2 Packs':52050953470232,'38C|Caramel|3 Packs':52050953503000,
'38C|Ivory|1 Pack':52050953535768,'38C|Ivory|2 Packs':52050953568536,'38C|Ivory|3 Packs':52050953601304,
'38C|Cocoa|1 Pack':52050953634072,'38C|Cocoa|2 Packs':52050953666840,'38C|Cocoa|3 Packs':52050953699608,
'38D|Beige|1 Pack':52050953732376,'38D|Beige|2 Packs':52050953765144,'38D|Beige|3 Packs':52050953797912,
'38D|Onyx|1 Pack':52050953830680,'38D|Onyx|2 Packs':52050953863448,'38D|Onyx|3 Packs':52050953896216,
'38D|Caramel|1 Pack':52050953928984,'38D|Caramel|2 Packs':52050953961752,'38D|Caramel|3 Packs':52050953994520,
'38D|Ivory|1 Pack':52050954027288,'38D|Ivory|2 Packs':52050954060056,'38D|Ivory|3 Packs':52050954092824,
'38D|Cocoa|1 Pack':52050954125592,'38D|Cocoa|2 Packs':52050954158360,'38D|Cocoa|3 Packs':52050954191128,
'40A|Beige|1 Pack':52050954223896,'40A|Beige|2 Packs':52050954256664,'40A|Beige|3 Packs':52050954289432,
'40A|Onyx|1 Pack':52050954322200,'40A|Onyx|2 Packs':52050954354968,'40A|Onyx|3 Packs':52050954387736,
'40A|Caramel|1 Pack':52050954420504,'40A|Caramel|2 Packs':52050954453272,'40A|Caramel|3 Packs':52050954486040,
'40A|Ivory|1 Pack':52050954518808,'40A|Ivory|2 Packs':52050954551576,'40A|Ivory|3 Packs':52050954584344,
'40A|Cocoa|1 Pack':52050954617112,'40A|Cocoa|2 Packs':52050954649880,'40A|Cocoa|3 Packs':52050954682648,
'40B|Beige|1 Pack':52050954715416,'40B|Beige|2 Packs':52050954748184,'40B|Beige|3 Packs':52050954780952,
'40B|Onyx|1 Pack':52050954813720,'40B|Onyx|2 Packs':52050954846488,'40B|Onyx|3 Packs':52050954879256,
'40B|Caramel|1 Pack':52050954912024,'40B|Caramel|2 Packs':52050954944792,'40B|Caramel|3 Packs':52050954977560,
'40B|Ivory|1 Pack':52050955010328,'40B|Ivory|2 Packs':52050955043096,'40B|Ivory|3 Packs':52050955075864,
'40B|Cocoa|1 Pack':52050955108632,'40B|Cocoa|2 Packs':52050955141400,'40B|Cocoa|3 Packs':52050955174168,
'40C|Beige|1 Pack':52050955206936,'40C|Beige|2 Packs':52050955239704,'40C|Beige|3 Packs':52050955272472,
'40C|Onyx|1 Pack':52050955305240,'40C|Onyx|2 Packs':52050955338008,'40C|Onyx|3 Packs':52050955370776,
'40C|Caramel|1 Pack':52050955403544,'40C|Caramel|2 Packs':52050955436312,'40C|Caramel|3 Packs':52050955469080,
'40C|Ivory|1 Pack':52050955501848,'40C|Ivory|2 Packs':52050955534616,'40C|Ivory|3 Packs':52050955567384,
'40C|Cocoa|1 Pack':52050955600152,'40C|Cocoa|2 Packs':52050955632920,'40C|Cocoa|3 Packs':52050955665688
  };

  /* ── Helpers ── */
  function getSelectedColor() {
    var radio = sectionEl.querySelector('fieldset.is-style-color input[type="radio"]:checked');
    if (radio) return radio.value;
    var label = sectionEl.querySelector('fieldset.is-style-color [update-value]');
    return label ? label.textContent.trim() : '';
  }

  /* ── 1. Checkout ── */
  var checkoutBtn = document.getElementById('bmsm-checkout-btn-' + sectionId);
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function() {
      var btn = this;
      if (btn.getAttribute('aria-busy') === 'true') return;

      var sizeInput = sectionEl.querySelector('input[is-value][name="option1"]');
      var size = sizeInput ? sizeInput.value : '';
      var color = getSelectedColor();

      var activeRow = sectionEl.querySelector('.hdt-bmsm-bundle-row.active');
      var bundleQty = activeRow ? parseInt(activeRow.getAttribute('data-qty')) : 1;
      var qtyStr = bundleQty === 1 ? '1 Pack' : bundleQty + ' Packs';

      // Check stock map first — must be in stock for this color+size
      if (!stock[color] || stock[color].indexOf(size) === -1) return;

      var key = size + '|' + color + '|' + qtyStr;
      var variantId = variantMap[key];
      if (!variantId) return;

      btn.setAttribute('aria-busy', 'true');
      btn.querySelector('.hdt-btn-atc_text').textContent = 'PROCESSING...';
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function(res) { return res.json(); })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.items || data.id) {
            window.location.href = '/checkout';
          } else {
            btn.removeAttribute('aria-busy');
            btn.querySelector('.hdt-btn-atc_text').textContent = 'CHECKOUT';
          }
        })
        .catch(function() {
          btn.removeAttribute('aria-busy');
          btn.querySelector('.hdt-btn-atc_text').textContent = 'CHECKOUT';
        });
    });
  }

  /* ── 2. Dialog patch (non-modal) ── */
  function patchDialogs() {
    sectionEl.querySelectorAll('.hdt-popover-variant').forEach(function(dialog) {
      if (dialog._bmsmPatched) return;
      dialog._bmsmPatched = true;
      dialog.showModal = function() { if (!this.open) this.show(); };
    });
  }
  patchDialogs();
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(patchDialogs).observe(sectionEl, { childList: true, subtree: true });
  }
  document.addEventListener('click', function(e) {
    sectionEl.querySelectorAll('.hdt-popover-variant[open]').forEach(function(dialog) {
      var popover = dialog.closest('hdt-popover');
      var trigger = popover ? popover.previousElementSibling : null;
      if (!dialog.contains(e.target) && e.target !== trigger && (!trigger || !trigger.contains(e.target))) {
        dialog.close();
      }
    });
  });

  /* ── 3. Bundle row selection ── */
  window.selectBundle = function(el, qty) {
    sectionEl.querySelectorAll('.hdt-bmsm-bundle-row').forEach(function(i) {
      i.classList.remove('active');
      var radio = i.querySelector('input[type="radio"]');
      if (radio) radio.checked = false;
    });
    el.classList.add('active');
    var activeRadio = el.querySelector('input[type="radio"]');
    if (activeRadio) activeRadio.checked = true;
    var form = sectionEl.querySelector('form');
    if (form) form.querySelector('input[name="quantity"]').value = qty;
  };

  /* ── 4. Product Switcher ── */
  sectionEl.querySelectorAll('.custom-listing-item').forEach(function(item) {
    item.addEventListener('click', function() {
      sectionEl.querySelectorAll('.custom-listing-item').forEach(function(i) { i.classList.remove('cat-active'); });
      sectionEl.querySelectorAll('.tab-content').forEach(function(c) { c.classList.remove('active'); });
      item.classList.add('cat-active');
      var targetId = item.dataset.target;
      sectionEl.querySelector('#' + targetId).classList.add('active');
    });
  });

  /* ── 5. Variant image handler ── */
  var imgScripts = sectionEl.querySelectorAll('script[id^="bmsm-variant-images-"]');
  imgScripts.forEach(function(script) {
    var variantImages = {};
    try { variantImages = JSON.parse(script.textContent); } catch(e) {}
    if (Object.keys(variantImages).length === 0) return;

    function updateImages() {
      var selectedOptions = Array.from(sectionEl.querySelectorAll('.hdt-variant-picker input[type="radio"]:checked, .hdt-variant-picker select'))
        .map(function(el) { return el.value.toLowerCase().trim(); });

      var matchedImages = null;
      for (var oi = 0; oi < selectedOptions.length; oi++) {
        if (variantImages[selectedOptions[oi]]) { matchedImages = variantImages[selectedOptions[oi]]; break; }
      }

      sectionEl.querySelectorAll('.hdt-bmsm-bundle-row').forEach(function(bundle, index) {
        var variantImg = matchedImages ? matchedImages[index] : null;
        var thumb = bundle.querySelector('.hdt-bmsm-bundle-thumb');
        if (!thumb) return;

        var defaultImgs = [null, null, null];
        try { defaultImgs = JSON.parse(bundle.dataset.defaultImages || '[]'); } catch(e) {}

        var qtyBadge = thumb.querySelector('.hdt-bmsm-bundle-qty-badge');

        if (variantImg) {
          var stack = thumb.querySelector('.hdt-bmsm-bundle-thumb-stack');
          if (stack) stack.remove();
          var imgEl = thumb.querySelector('.hdt-bmsm-bundle-img');
          if (imgEl) { imgEl.src = variantImg; imgEl.srcset = variantImg; }
          else {
            var newImg = document.createElement('img');
            newImg.className = 'hdt-bmsm-bundle-img';
            newImg.src = variantImg;
            if (qtyBadge) thumb.insertBefore(newImg, qtyBadge); else thumb.appendChild(newImg);
          }
          thumb.style.display = '';
        } else {
          var validDefaults = defaultImgs.filter(function(d) { return d !== null; });
          if (validDefaults.length >= 1) {
            var imgEl2 = thumb.querySelector('.hdt-bmsm-bundle-img');
            if (imgEl2) { imgEl2.src = validDefaults[0]; imgEl2.srcset = validDefaults[0]; }
            else {
              var newImg2 = document.createElement('img');
              newImg2.className = 'hdt-bmsm-bundle-img';
              newImg2.src = validDefaults[0];
              if (qtyBadge) thumb.insertBefore(newImg2, qtyBadge); else thumb.appendChild(newImg2);
            }
            thumb.style.display = '';
          }
        }
      });
    }

    sectionEl.addEventListener('change', function(e) {
      if (e.target.closest('hdt-variant-picker')) updateImages();
    });
    setTimeout(updateImages, 100);
  });

  /* ── 6. Size label update ── */
  var sizeEquivalents = {
    'AA':'28A, 30A, 32A, 28B, 30B, 28C','A':'34A, 32B, 30C, 28D','B':'36A, 34B, 32C, 30D, 28DD/E',
    'C':'38A, 36B, 34C, 32D, 30DD/E, 28DDD/F','D':'40A, 38B, 36C, 34D, 32DD/E, 30DDD/F, 28G',
    'E':'42A, 40B, 38C, 36D, 34DD/E, 32DDD/F, 30G, 28H','F':'44A, 42B, 40C, 38D, 36DD/E, 34DDD/F, 32G, 30H, 28I',
    'G':'44B, 42C, 40D, 38DD/E, 36DDD/F, 34G, 32H, 30I, 28J','H':'44C, 42D, 40DD/E, 38DDD/F, 36G, 34H, 32I, 30J, 28K',
    'I':'44D, 42DD/E, 40DDD/F, 38G, 36H, 34I, 32J, 30K, 28L','J':'44DD/E, 42DDD/F, 40G, 38H, 36I, 34J, 32K, 30L, 28M',
    'K':'44DDD/F, 42G, 40H, 38I, 36J, 34K, 32L, 30M, 28N','L':'44G, 42H, 40I, 38J, 36K, 34L, 32M, 30N, 28O',
    'M':'44H, 42I, 40J, 38K, 36L, 34M, 32N, 30O, 28P','N':'44I, 42J, 40K, 38L, 36M, 34N, 32O, 30P, 28Q',
    'O':'42K, 40L, 38M, 36N, 34O, 32P, 30Q, 28R','P':'42L, 40M, 38N, 36O, 34P, 32Q, 30R',
    'Q':'42M, 40N, 38O, 36P, 34Q, 32R, 30S','R':'44M, 42N, 40O, 38P, 36Q, 34R, 32S, 30T, 28U',
    'A/B':'34A, 32B, 30C, 28D','C/D':'38A, 36B, 34C, 32D, 30DD/E',
    'DD/E/F':'44A, 42B, 40C, 38D, 36DD/E, 34DDD/F','G/H':'44C, 42D, 40DD/E, 38DDD/F, 36G, 34H, 32I, 30J, 28K',
    'I/J/K':'44D, 42DD/E, 40DDD/F, 38G, 36H, 34I, 32J, 30K, 28L'
  };
  document.addEventListener('change', function(e) {
    var target = e.target;
    if (target.matches('hdt-richlist') || (target.tagName === 'INPUT' && target.closest('fieldset.is-style-size'))) {
      var fieldset = target.closest('fieldset.is-style-size');
      if (!fieldset) return;
      var val = target.getAttribute('selected') || target.value;
      if (!val) return;
      var labelSpan = fieldset.querySelector('[update-value]');
      if (labelSpan) labelSpan.textContent = val;
      var selectBtn = fieldset.querySelector('button.hdt-select');
      if (selectBtn) selectBtn.textContent = 'SIZE ' + val;
    }
  });

  /* ── 7. Sync variant ID to form ── */
  var formEl = document.getElementById(sectionEl.querySelector('form') ? sectionEl.querySelector('form').id : '');
  function syncVariantId() {
    var sizeInput = sectionEl.querySelector('input[is-value][name="option1"]');
    var size = sizeInput ? sizeInput.value : '';
    var color = getSelectedColor();
    if (!size || !color) return;

    var match = variantsData.find(function(v) {
      return v.options[0] === size && v.options[1] === color && v.options[2] === '1 Pack';
    });
    if (match && formEl) {
      var idInput = formEl.querySelector('input[name="id"]');
      if (idInput) idInput.value = match.id;
    }
  }
  sectionEl.addEventListener('change', syncVariantId);
  sectionEl.addEventListener('click', function() { setTimeout(syncVariantId, 100); });
  setTimeout(syncVariantId, 500);

  /* ── 8. Hardcoded stock map — sizes with 1 Pair qty > 0 per color ── */
  var stock = {                       
    'Beige':   ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36D','36E','38A','38B','38C','38D','40A','40B','40C'],
    'Onyx':    ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36D','36E','38A','38B','38C','38D','40A','40B','40C'],
    'Caramel': ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36E','38A','38B','38C','38D','40A','40B','40C'],
    'Ivory':   ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36D','36E','38A','38B','38C','38D','40A','40B','40C'],
    'Cocoa':   ['32A','32B','32C','32D','32E','32F','34A','34B','34C','34D','34E','34F','36A','36B','36C','36D','36E','38A','38B','38C','38D','40A','40B','40C']
  };

  function filterSizes() {
    var color = getSelectedColor();
    if (!color || !stock[color]) return;
    var ok = {};
    stock[color].forEach(function(s) { ok[s] = 1; });
    var buttons = sectionEl.querySelectorAll('fieldset.is-style-size [role="option"]');
    if (!buttons.length) buttons = sectionEl.querySelectorAll('fieldset[data-index="0"] [role="option"]');
    buttons.forEach(function(btn) {
      btn.style.display = ok[btn.getAttribute('value')] ? '' : 'none';
    });
  }

  filterSizes();
  setTimeout(filterSizes, 300);
  setTimeout(filterSizes, 800);
  document.addEventListener('DOMContentLoaded', filterSizes);
  sectionEl.querySelectorAll('fieldset.is-style-color input[type="radio"]').forEach(function(radio) {
    radio.addEventListener('change', function() { setTimeout(filterSizes, 50); });
  });
  sectionEl.querySelectorAll('fieldset.is-style-color label').forEach(function(label) {
    label.addEventListener('click', function() { setTimeout(filterSizes, 100); });
  });
  sectionEl.addEventListener('click', function() { setTimeout(filterSizes, 150); });
  setInterval(filterSizes, 800);

})();
